import { Winner } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardWinners: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<Winner[]> = (fetchContext, awardId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/winners`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<Winner[]>(fetchContext.errorStore, response, 'get award winners'));
